import apiCopomexToken from "./apiCopomexToken";


const sepomexApiConfig = {
    BASE_URL: 'https://api.copomex.com',
    PATH: '/query/info_cp',
    HTTP_PARAMS: `type=simplified&token=${ apiCopomexToken }`,
};

export default sepomexApiConfig;